import gql from 'graphql-tag';
import { print } from 'graphql/language/printer';
import FetchClient, { AbortType, FetchClientError } from './FetchClient';
export { gql };
export class GqlError extends FetchClientError {
    get errors() {
        return this.responseBody.errors || [];
    }
}
export default class GqlClient {
    _endpoint;
    _fetchClient;
    constructor(options) {
        this._endpoint = options.endpoint;
        this._fetchClient = options.fetchClient || new FetchClient();
    }
    execute(query, variables) {
        const request = this._fetchClient.postJson(this._endpoint, {
            query: typeof query === 'string' ? query : print(query),
            variables,
        });
        return {
            abort: request.abort,
            response: (async () => {
                try {
                    const response = await request.response;
                    if (response.errors) {
                        throw new GqlError('GraphQL request failed', AbortType.UNKNOWN, 0, response);
                    }
                    else {
                        return response;
                    }
                }
                catch (err) {
                    if (err instanceof FetchClientError && err.responseBody) {
                        throw new GqlError(err.message, err.abortType, err.status, err.responseBody);
                    }
                    else {
                        throw err;
                    }
                }
            })(),
        };
    }
}
//# sourceMappingURL=GqlClient.js.map